import HomeRounded from "@mui/icons-material/HomeRounded";

import { Route } from "react-router-dom";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { rootProtectedPath } from "data/authData";
import moment from "moment";
import StoreRecommendation from "./StoreRecommendation";

export const reportsBackgroundColor = "#F2F3F4";

export const storeRecommendationDashboardSideNavList = {
	HOME: { name: "Home", key: "HOME", display: true, icon: <HomeRounded /> },
};

// Recursive function to build routes
export const generateStoreRecommendationRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types)
		return (
			<Route key={service.key} path={service.key}>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateStoreRecommendationRoutesFromServiceTree(service.types[childKey], rootPath),
					)}
			</Route>
		);
	else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={storeRecommendationDashboardSideNavList}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={rootProtectedPath}
						sx={{ background: reportsBackgroundColor }}
					/>
				}>
				<Route index element={<StoreRecommendation />} />
			</Route>
		);
};
